// extracted by mini-css-extract-plugin
module.exports = {"addFavoriteTeam":"FavoriteTeamButton_addFavoriteTeam__ugvmi","addFavoriteTeamLabel":"FavoriteTeamButton_addFavoriteTeamLabel__Gw2uz","isAdded":"FavoriteTeamButton_isAdded____sa1"};